import { ClienteModel } from 'app/model/cliente/cliente.model';
import { ProdutoModel } from './produto.model';
export class PrecoProdutoClienteModel {
  id: number;
  code: string;
  utilizacao: number;
  armazenagem: number;
  movImplantacao: number;
  movEntrada: number;
  movSaidaNormal: number;
  movSaidaUrgente: number;
  transImplantacao: number;
  transEntrada: number;
  transSaidaNormal: number;
  transSaidaUrgente: number;
  dataAtual: Date;
  produtoServico: ProdutoModel;
  cliente: ClienteModel;
}



// WEBPACK FOOTER //
// /app/src/app/model/produto/preco-produto-cliente.ts